import {
  AppControllerRef,
  AppController as DsAppController,
} from '@wix/document-services-types';
import { PrivateAPINamespace } from '../PrivateAPINamespace';
import { DocumentServices } from '../../types';
import { ComponentRef } from '@wix/editor-platform-sdk-types';

class AppController {
  public id: string;
  public settings: string;

  constructor(
    private ds: DocumentServices,
    private appController: DsAppController,
  ) {
    this.id = this.appController.id!;
    this.settings = this.appController.settings!;
  }

  public update(newSettings: string): void {
    return this.ds.platform.controllers.settings.set(
      { id: this.appController.id, type: 'data' } as AppControllerRef,
      newSettings,
    );
  }
}

export class ControllersNamespace extends PrivateAPINamespace {
  static readonly namespace = 'controllers';

  public async get(appDefinitionId: string, compRef: ComponentRef) {
    return this.ps.ds.platform.controllers
      .getAvailableScopedControllers(compRef)
      .concat(
        this.ps.ds.platform.controllers.getControllerDataPointersByAppDefId(
          'dataBinding',
        ) as DsAppController[],
      )
      .filter((controller) => controller.applicationId === appDefinitionId)
      .map((appController) => new AppController(this.ps.ds, appController));
  }
}
